mutation DefineBimClass(
    $id: ID
    $definition: BimClassSource!
) {
    defineBimClass(
        id: $id
        definition: $definition
    ) {
        bimClass {
            id
            revisionID
        }
        errors {
            message
        }
    }
}
